/* eslint-disable @typescript-eslint/no-explicit-any */
// START GENAI@GHCOPILOT
const logRocketTrack = (window as any).LogRocket && (window as any).LogRocket.track;
const logRocketError = (window as any).LogRocket && (window as any).LogRocket.captureException;
const dataDogTrack = (window as any).DataDog && (window as any).DataDog.addAction;

export const trackEvent = (eventName: string, eventData?: Record<string, any>): void => {
  logRocketTrack?.(eventName, eventData);
  dataDogTrack?.(eventName, eventData);
};

export const trackError = (error: string, eventData?: Record<string, any>): void => {
  logRocketError?.(error, {
    tags: {
      event: 'error',
      ...eventData
    },
    extra: eventData
  });

  dataDogTrack?.('error', {
    message: error,
    // stack: error.stack,
    ...eventData
  });
};
// END GENAI@GHCOPILOT
